import { Box, CircularProgress, Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { getYotpoInstallUrl } from "@/api/yotpoIntegration";

export const Route = createFileRoute("/_auth/connectors/$siteId/yotpo/install")(
  {
    loader: async ({ params }) => {
      const { siteId } = params;

      const MAX_RETRIES = 10;
      const RETRY_DELAY_MS = 200;

      for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
        try {
          const url = await getYotpoInstallUrl(siteId);
          return { redirectUrl: url };
        } catch (error) {
          const isRetryable =
            error instanceof Error &&
            error.message === "JWT client not available" &&
            attempt < MAX_RETRIES - 1;

          if (!isRetryable) {
            throw redirect({
              to: "/dragon-tiles/$siteId",
              params: { siteId },
              replace: true,
            });
          }

          await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
        }
      }

      throw redirect({
        to: "/dragon-tiles/$siteId",
        params: { siteId },
        replace: true,
      });
    },
    component: YotpoInstallRedirect,
  },
);

function YotpoInstallRedirect() {
  const { redirectUrl } = Route.useLoaderData();

  useEffect(() => {
    window.location.replace(redirectUrl);
  }, [redirectUrl]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
        p: 5,
      }}
    >
      <CircularProgress />
      <Typography>Redirecting to Yotpo...</Typography>
    </Box>
  );
}
